// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__MCYkF","productName":"Table_productName__qgO9T"};